import React from "react";
import { useDispatch } from "react-redux";
import { Modal } from "@/components/modal/modal";

import { hideModal } from "actions/modal";

import { Button } from "@/components/ui/button";

const MediaPickerModal = () => {
  const dispatch = useDispatch();

  return (
    <Modal
      show={true}
      onHide={() => dispatch(hideModal())}
      animation={false}
      contentClassName="p-4 gap-4"
    >
      <Modal.Header closeButton>
        <Modal.Title>Select / Upload media</Modal.Title>
      </Modal.Header>
      <Modal.Body>upload media here, eventually</Modal.Body>
      <Modal.Footer className="justify-end">
        <Button
          variant="blue-primary"
          size="md"
          onClick={() => dispatch(hideModal())}
        >
          Select
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default MediaPickerModal;
